/**
 * Stamp `data-pb-section` onto a section's root element.
 *
 * Every consumer of a section's CSS depends on this: the parser rewrites
 * `#sectionId` selectors to `:is(#sectionId, [data-pb-section="sectionId"])`
 * (`parsers/section-parser.js`) and strips the root `id` from the stored HTML
 * (`parsers/build-template-sections.js`), so the attribute is the ONLY thing
 * that lets a section's own rules match its own markup.
 *
 * Extracted from `renderer/iframe-renderer.js` when the section code viewer
 * became the second surface that had to produce renderable section markup
 * outside the canvas. Kept as one copy on purpose — a second implementation
 * would drift silently, because a section whose root carries no attribute does
 * not error, it just renders unstyled.
 */
export function stampSectionRootAttribute(html, sectionId) {
  if (typeof DOMParser === 'undefined') return html;
  const parser = new DOMParser();
  const doc = parser.parseFromString(`<div>${html}</div>`, 'text/html');
  const root = doc.body.firstElementChild;
  const sectionEl = root?.firstElementChild;
  if (sectionEl) {
    sectionEl.setAttribute('data-pb-section', sectionId);
    sectionEl.removeAttribute('id');
  }
  return root ? root.innerHTML : html;
}
